<template>
  <v-card class="mx-auto my-12 col-md-8 offset-md-0 col-12 offset-0">
    <!-- src="https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/logo%2FlogoSOS.jpg?alt=media&token=ea70f774-d2f5-4f46-a130-ba39b2863064" -->
    <v-img
      height="auto"
      :src="require('../assets/SOS982x640_High3.jpg')"
    >
    </v-img>
<!-- class="textWordBreak display-1 pt-6 justify-center font-weight-medium" -->
    <v-card-title
      
      class="blue-grey--text pt-6 text-md-h4 text-sm-h5 text-xs-h6 font-weight-bold justify-center textWordBreak"
      >НАМ ВАЖНА ЛЮБАЯ ПОМОЩЬ ! ! !</v-card-title
    >
    <v-card-title class="textWordBreak text-md-h5 text-sm-h5 text-xs-h6 text-decoration-underline"
      >Расчетный счет Беларусбанка</v-card-title
    >
    <v-card-text>
      <v-row align="center" class="mx-0">
        <div class="textTimelinesSOS ml-4 text-left subtitle-1" style="line-height: 1.6rem;">
          BY45 AKBB 3135 0541 9035 9230 0000 <br />
          УНП 390 541 065 <br />
          ОАО "АСБ Беларусбанк", г.Полоцк <br />
          код банка (БИК) АКВВВУ2Х <br />
          Благотворительное общественное объединение помощи безнадзорным
          животным "Право на жизнь" <br />
          Сокращённо БООПБЖ "Право на жизнь".
        </div>
      </v-row>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <v-card-title class="textWordBreak cardTitleSOS text-md-h5 text-sm-h5 text-xs-h6 text-decoration-underline">Прием платежей в ЕРИП</v-card-title>

    <v-card-text class="pb-0">
      <v-row align="center" class="mx-0">
        <div class="textTimelinesSOS ml-4 subtitle-1 text-left">
          Код услуги: 200133
        </div>
      </v-row>
    </v-card-text>

    <v-card-title
      class="ml-4 text-left body-1 textTimelinesSOS"
      style="font-weight: bold"
    >
      Путь ветки ЕРИП:
    </v-card-title>
    <div class="ml-0 text-left">
      <v-timeline class="overline ml-4 pt-0" align-center dense>
        <v-timeline-item
          icon="mdi-arrow-down"
          class="text-left pb-2 textTimelinesSOS"
          ><div class="mt-3">Благотворительность, общественные объединения</div>
        </v-timeline-item>
        <v-timeline-item
          icon="mdi-arrow-down"
          class="text-left pb-2 textTimelinesSOS"
          ><div class="mt-3">Защита животных</div>
        </v-timeline-item>
        <v-timeline-item
          icon="mdi-arrow-down"
          class="text-left pb-2 textTimelinesSOS"
          ><div class="mt-3">Право на жизнь</div>
        </v-timeline-item>
        <v-timeline-item
          icon="mdi-arrow-down"
          class="text-left pb-2 textTimelinesSOS"
          ><div class="mt-3">
            Пожертвование (назначение можно указать в разделе - фамилия)
          </div>
        </v-timeline-item>
      </v-timeline>
    </div>

    <v-divider class="mx-4 mt-4"></v-divider>

    <v-card-title class="textWordBreak cardTitleSOS text-md-h5 text-sm-h5 text-xs-h6 text-decoration-underline"
      >Пожертвовать приюту с любой карты</v-card-title
    >
    <v-timeline class="overline ml-4 pt-0" align-center dense>
      <v-timeline-item color="#689F38" class="text-left pb-2 textTimelinesSOS">
        <template v-slot:icon>
          <v-icon size="2em" dark> mdi mdi-hand-pointing-right </v-icon>
        </template>
        <div class="mt-3">
          <a
            target="blank"
            class="text-decoration-none"
            href="https://vk.com/away.php?to=http%3A%2F%2Fmoney.yandex.ru%2Fto%2F410019324270716&cc_key="
          >
            money.yandex.ru/to/410019324270716
          </a>
        </div>
      </v-timeline-item>
    </v-timeline>
    
    <v-divider class="mx-4 mt-4"></v-divider>

     <v-card-title class="textWordBreak cardTitleSOS text-md-h5 text-sm-h5 text-xs-h6 text-decoration-underline">SMS пожертвование</v-card-title>

    <!-- <v-card-text class="pb-0">
      <v-row align="center" class="mx-0">
        <div class="textTimelinesSOS ml-4 subtitle-1 text-left">
         Отправьте SMS на номер <span>553</span>
        </div>
      </v-row>
    </v-card-text> -->
     

     <v-card-title
        class="ml-4 text-left h5 textTimelinesSOS font-weight-bold"
        style="line-height: 1.5rem;"
      >
        <div >
          Отправьте SMS на номер: <span class="ml-2 font-weight-black text-decoration-underline" style="color: #7E57C2; ">553</span>
        </div>
      </v-card-title>

    <v-card-title
      class="ml-4 text-left body-1 textTimelinesSOS font-weight-bold"
     
    >
      Шаблон SMS сообщения:
    </v-card-title>
    <div class="ml-0 text-left">
      <v-timeline class="overline ml-4 pt-0" align-center dense>
        <v-timeline-item
          icon="mdi-arrow-right"
          color="deep-purple lighten-1"
          class="text-left pb-2 textTimelinesSOS"
          ><div class="mt-3" >1223 &#10148;
            <span style="color: red;"> ПРОБЕЛ </span> 
            &#10148;	 Ваш номер <span style="font-size: 150%;">&#9742;</span> &#10148;
            <span style="color: red;"> ПРОБЕЛ </span> &#10148;
            сумма пожертвования
          </div>
        </v-timeline-item>
        <v-timeline-item
          icon="mdi-arrow-right"
          color="deep-orange lighten-1"
          class="text-left pb-2 textTimelinesSOS"
          ><div class="mt-3 font-weight-bold" >Пример текста SMS:
            <span style="font-size: 150%; color: #0091EA;">1223 37529******* 1</span>
          </div>
        </v-timeline-item>
      </v-timeline>

      <v-card-text class="pb-0">
        <v-row align="center" class="mx-0 ">
          <div class="red--text textTimelinesSOS ml-4 subtitle-1 text-left">
         Пробел между параметрами обязателен!
          </div>
        </v-row>
      </v-card-text>
      <v-card-title
        class="ml-4 text-left h5 textTimelinesSOS font-weight-bold"
        style="font-weight: bold"
      >
        Сумма пожертвования может быть любой!
      </v-card-title>
      <v-alert
        border="top"
        colored-border
        type="info"
        elevation="2"
        class="ml-7 mr-5 mb-8 text-left h5 textTimelinesSOS "
        
      >
        Для осуществления операций в системе iPay доступна не вся сумма баланса лицевого счёта:
        после списания итоговой суммы операциина вашем счете должно остаться не менее 10 копеек для абонента МТС
        и не менее 50 копеек для абонента Life:) 
      </v-alert>

      
    </div>

    <v-divider class="mx-4 mt-4"></v-divider>

    <v-card-title class="textWordBreak cardTitleSOS text-md-h5 text-sm-h5 text-xs-h6 text-decoration-underline">Пожертвование в копилки приюта</v-card-title>
    <v-row>
      <v-col
        class="col-md-6 offset-0 col-lg-6 col-xl-4 col-12"
        v-for="(item, k) in moneyBoxInfo"
        :key="k"
      >
        <v-lazy
          v-model="isActive"
          :options="{ threshold: 0.5 }"
          transition="fade-transition"
        >
          <v-card 
            class="mx-auto mb-1" 
            max-width="450" 
            min-height="420"
            elevation="6"
          >
            <v-img :src="item.image"></v-img>

            <v-card-title class="justify-center">
              <v-row no-gutters>
                <v-col cols="2">
                  <div class="pr-5">
                    <v-avatar :color="item.color" size="35">
                      <span class="white--text headline">{{ item.number }}</span>
                    </v-avatar>
                  </div>
                </v-col>
                <v-col cols="10">
                  <span class="textWordBreak">{{ item.name }}</span>
                </v-col>
              </v-row>
            </v-card-title>

            <v-divider :class="item.color"></v-divider>

            <v-card-text>
              <div class="textWordBreak">{{ item.address }}</div>
            </v-card-text>
          </v-card>
        </v-lazy>
      </v-col>
    </v-row>

    <v-card-title class="textWordBreak pt-10">Копилки приюта на карте</v-card-title>
      <v-card class="mx-5 justify-center align-center text-center" >
          <monney-box></monney-box>
      </v-card>

      
  </v-card>
</template>

<script>
import MonneyBox from "../components/MapMonneyBoxs.vue";
export default {
  data: () => ({
    isActive: false,
    
    // winHeight: null,
    moneyBoxInfo: [
      {
        image:
          "https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F1%2F1.jpg?alt=media&token=7e05acf9-cbbe-45c5-a63a-1ea4af34e222",
        name: 'Кафе "СУШИWOK"',
        address:
          "НОВОПОЛОЦК, ул. Молодёжная 148В (здание возле ТЦ 'Олимп'). Режим работы 10.00 - 23.00",
        color: "deep-purple accent-4",
        number: "1",
      },
      {
        image:
          "https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F2%2F2.jpg?alt=media&token=5d7e5e9d-1653-4edf-99fb-f7f2abeda54a",
        name: 'Зоомагазин "Таити"',
        address:
          "Полоцк, ул. Пушкина, 15. Режим работы: 09.00 - 18.00 (будние), 09.00 - 15.00 (выходные)",
        color: "light-green darken-1",
        number: "2",
      },
      {
        image:
          "https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F3%2F3.jpg?alt=media&token=525c5006-cdfe-476e-9b13-2f8199fa8af0",
        name: 'Зоомагазин "Мокрый Нос"',
        address:
          'Полоцк, ул. Ф.Скорины, 45 (ТЦ "Стрелецкий Респект"). Режим работы: 09.00 - 19.00 (будние), 09.00 - 17.00 (выходные)',
        color: "orange darken-3",
        number: "3",
      },
      {
        image:
          "https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F4%2F4.jpg?alt=media&token=eef364c7-b61d-49c3-8410-7341a5c2b75d",
        name: 'Зоомагазин "Таити"',
        address:
          "Полоцк, ул. Гоголя, 24. Режим работы: 09.00 - 18.00 (будние), 09.00 - 15.00 (выходные)",
        color: "light-blue accent-4",
        number: "4",
      },
      {
        image:
          "https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F5%2F5.jpg?alt=media&token=010e3b5c-6dee-4f63-87a5-f872a79a49f5",
        name: 'Парикмахерская "Вояж"',
        address:
          "Полоцк, ул. Октябрьская, 40 (здание автовокзала, 2-й этаж). Режим работы: 08.00 - 19.00, воскресенье: 09.00 - 15.00",
        color: "red darken-3",
        number: "5",
      },
      {
        image:
          "https://firebasestorage.googleapis.com/v0/b/dog-shelter-d9a79.appspot.com/o/monneyBoxes%2F6%2F6.jpg?alt=media&token=af3b4633-4cfb-4f9c-b725-6b4e507ab548",
        name: 'Кафе "БyFet"',
        address:
          "Полоцк, ул. Свердлова, 18А. Режим работы: 11.00 - 18.00 (вс-чт), 11.00 - 23.00 (пт-сб)",
        color: "brown darken-2",
        number: "6",
      },
    ],
  }),


  methods: {
    goBack() {
      window.history.back();
    },
    // selectEmoji(emoji) {
    //   console.log(emoji)
    // }
  },

  components: {
    MonneyBox,
    // VEmojiPicker
  },

  

};
</script>

<style scoped>
.cardTitleSOS {
  padding-top: 2rem;
}

.textTimelinesSOS {
  /* letter-spacing: 0.13125em !important; */
  /* font-size: 0.855rem !important; */
  line-height: 1.2rem;
  word-break: break-word !important;
  white-space: normal !important;
  color: #546e7a !important;
}

</style>
